import { InjectionToken } from '@angular/core';

export interface CapicheVersionConfig {
  version?: string; // Make the version field optional
}

// Define the InjectionToken
export const CAPICHE_VERSION_CONFIG = new InjectionToken<CapicheVersionConfig>('CapicheAuthConfig', {
  factory: () => ({ version: 'not defined' }),
});
